import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/sections/HeroSection";

// Below-the-fold sections are code-split to keep the initial JS bundle small.
const VideoShowcase = lazy(() => import("@/components/sections/VideoShowcase"));
const CrossfitSection = lazy(() => import("@/components/sections/CrossfitSection"));
const CoursesSection = lazy(() => import("@/components/sections/CoursesSection"));
const PricingSection = lazy(() => import("@/components/sections/PricingSection"));
const BoxSection = lazy(() => import("@/components/sections/BoxSection"));
const CoachesSection = lazy(() => import("@/components/sections/CoachesSection"));
const EventsSection = lazy(() => import("@/components/sections/EventsSection"));
const CoachingSection = lazy(() => import("@/components/sections/CoachingSection"));
const FAQSection = lazy(() => import("@/components/sections/FAQSection"));
const ContactSection = lazy(() => import("@/components/sections/ContactSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <HeroSection />
        <Suspense fallback={null}>
          <VideoShowcase />
          <CrossfitSection />
          <CoursesSection />
          <PricingSection />
          <BoxSection />
          <CoachesSection />
          <EventsSection />
          <CoachingSection />
          <FAQSection />
          <ContactSection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
